class expandableMenu extends HTMLElement {
  constructor() {
    super();
    this.titleItems = this.querySelectorAll('.expandable-menu__item-title');
    this.btnOpenPopup = this.querySelectorAll('.btn-open-popup');
    this.btnClosePopup = this.querySelectorAll('.btn-close-popup');
  }

  connectedCallback() {
    this.toggleContent();
    this.handleStickyOnScroll();
    this.videoPopup();
  }

  videoPopup() {
    this.btnOpenPopup.forEach((btnOpenPopup) => {
      btnOpenPopup.addEventListener('click', function () {
        const selfpopUp = btnOpenPopup.closest('.expandable-menu__item');
        selfpopUp.querySelector('.popup-collapsible').classList.remove('hidden');
        document.querySelector('body').classList.add('overflow-hidden');
      });
    });
    this.btnClosePopup.forEach((btnClosePopup) => {
      btnClosePopup.addEventListener('click', function () {
        const selfpopUp = btnClosePopup.closest('.expandable-menu__item');
        selfpopUp.querySelector('.popup-collapsible').classList.add('hidden');
        document.querySelector('body').classList.remove('overflow-hidden');
      });
    });
  }

  toggleContent() {
    const showLessContent = this.querySelectorAll('.expandable-menu__item-showless');
    if (this.titleItems.length > 0) {
      this.titleItems.forEach((titleItem) => {
        if (titleItem) {
          titleItem.addEventListener('click', (event) => {
            this.titleItems.forEach((item) => {
              if (item !== titleItem) {
                item.parentNode.classList.remove('active');
              }
            });
            titleItem.parentNode.classList.toggle('active');
            this.handleStickyOnScroll();
            const titleItemRect = titleItem.getBoundingClientRect();
            if (window.innerWidth < 990) {
              titleItem.scrollIntoView({
                top: document.querySelector('.rocket-header').offsetHeight + 17,
                behavior: 'smooth',
              });
            }
          });
        }
      });
    }
    if (showLessContent.length > 0) {
      showLessContent.forEach((showLess) => {
        if (showLess) {
          showLess.addEventListener('click', (event) => {
            showLess.closest('.expandable-menu__item').classList.remove('active');
            this.handleStickyOnScroll();
            const positionShowLess = showLess.closest('.expandable-menu__item');
            const showLessItemRect = positionShowLess.getBoundingClientRect();
            window.scrollTo({
              top: showLessItemRect.top,
              behavior: 'smooth',
            });
          });
        }
      });
    }
  }
  handleStickyOnScroll() {
    window.addEventListener('scroll', this.stickyTitleMb.bind(this));
    this.stickyTitleMb();
  }
  stickyTitleMb() {
    const activeItems = this.querySelectorAll('.expandable-menu__item');
    activeItems.forEach((elmActive, indexItem) => {
      const titleItemRect = elmActive.getBoundingClientRect();
      const itemHeight = elmActive.querySelector('.expandable-menu__item-title').offsetHeight;
      const headerHeight = document.querySelector('.rocket-header').offsetHeight;
      const mobileActiveItem = headerHeight + 74;
      const mobileNoActiveItem = headerHeight + 34;
      const mobileUnActiveItem = headerHeight + 114;
      if (elmActive.classList.contains('active')) {
        const disableSticky = itemHeight + headerHeight + 200;
        const itemTop = titleItemRect.top;
        const itemBottom = titleItemRect.bottom;
        if (itemBottom <= disableSticky) {
          elmActive.classList.add('sticky-element');
        } else {
          elmActive.classList.remove('sticky-element');
        }
      }
      if (titleItemRect.top < mobileActiveItem && titleItemRect.top > mobileNoActiveItem) {
        elmActive.classList.add('mobile-active');
      } else {
        elmActive.classList.remove('mobile-active');
      }
      if (indexItem === 0 && titleItemRect.top > mobileActiveItem) {
        elmActive.classList.add('mobile-active');
      }
    });
  }
}

customElements.define('expandable-menu', expandableMenu);
